(function($) {
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init)
  
  function init() {    
  	completeStepsHighlight.init()
    metafieldLogic.init()
  }
  
  const metafieldLogic = {
    init() {
      this.setDataAttributes()
      document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', this.setDataAttributes.bind(this))
      document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', this.setDataAttributes.bind(this))
    },
    setDataAttributes() {
        const mainCategory = $('.cpb-category.metafield-logic-main').attr('data-metafield-logic-processed', true).attr('data-metafield-logic-main', '')
        if(mainCategory.length === 0) return
        const categories = $('.cpb-category:not([data-metafield-logic-processed])')
        categories.each(function() {
          const category = $(this).attr('data-metafield-logic-processed', true)
          const categoryObj = getState.panelCategoryByCategoryElement(this).category
          const metafield = categoryObj.metafields?.find(function(item) {return item.key === 'metafield_logic_show'})
          if(!metafield) return
          category.attr('data-metafiled-logic-value', metafield.value)
        })
        this.checkLogicInDOM(mainCategory)
    },
    checkLogicInDOM(mainCategory) {
      setTimeout(function() {
        const selectedOption = mainCategory.find('.option-label')[0].childNodes[0].data
        const categories = $('.cpb-category[data-metafiled-logic-value]')
        categories.each(function() {
          const category = $(this)
          const logicValue = category.attr('data-metafiled-logic-value')
          category.attr('data-metafield-logic-shown', logicValue === selectedOption)
        })
      })
    }
  }
  
  const completeStepsHighlight = {
    init() {
      const that = this
      this.update()
      document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(e) {
        setTimeout(function() {
          that.update()
        })
      })

      const resetButton = $('.cpb-reset-button')
      resetButton.on('click', function() {
        setTimeout(function() {
          $('.swal2-confirm').one('click', function() {
            that.reset()
          })
        })        
      })
    },
    update() {
      const currentPanel = $('.cpb-panels-container .react-tabs__tab-list .react-tabs__tab.cpb-active')
      const visibleNotIgnoredCategories = $('.cpb-category:not(.complete-step-ignore)')
      
      let filledCategoriesQuantity = 0
      let clearingCategoriesQuantity = 0
      
      for(let i = 0; i < visibleNotIgnoredCategories.length; i++) {
        const category = getState.panelCategoryByCategoryElement(visibleNotIgnoredCategories[i]).category
        if(getState.isCategoryFilled(category)) {
        	filledCategoriesQuantity++
            if(category.clearPrevious === 'panel' || category.clearNext === 'panel') clearingCategoriesQuantity++
        }
      }
      
      if(visibleNotIgnoredCategories.length === filledCategoriesQuantity) {
      	currentPanel.attr('data-cpb-custom-filled', true)
        return
      } else if(clearingCategoriesQuantity > 0) {
        currentPanel.attr('data-cpb-custom-filled', true)
        return
      }
      
      currentPanel.attr('data-cpb-custom-filled', false)
    },
    reset() {
      $('.cpb-panels-container .react-tabs__tab-list .react-tabs__tab').attr('data-cpb-custom-filled', false).eq(0).trigger('click')
    }
  }
  
  const getState = {
    categoryId(el) {
      for(let i = 0; i < el.classList.length; i++) {
        if(el.classList.contains('cpb-category-' + el.classList[i])) return el.classList[i];
      }
      return false;
    },
    panelCategoryByCategoryId(id) {
      if(!id) return {panel: false, category: false};
      const panels = CPB.getStore().getState().Product.panels;
      let category = false;
      const panel = panels.find(panel => {
        category = panel.categories.find(category => category.id === id);
        return category;
      });
      return category ? {panel, category} : {panel: false, category: false};
    },
    panelCategoryByCategoryElement(el) {
      return this.panelCategoryByCategoryId(this.categoryId(el));
    },
    isCategoryFilled(categoryObj, product = CPB.getStore().getState().Product) {
      return !!product.layers.find(layer => layer.category === categoryObj.id);
    }
  }
})(jQuery)